import type { HTMLAttributes } from 'react';
import React from 'react';
import type { ClassReportStudentType, HighlightedProps } from '../../../pages/types';
import type { ProgressConsistencyProps } from './types';
import type { GenderType } from '../../../util/types';
import { Tooltip } from '../../index';
import ProgressConsistencyWrapper from './components/ProgressConsistencyWrapper';
import StudentIcon from '../student-scatter/components/StudentIcon';
import { STUDENT_PROGRESS_CLASSES } from '../helpers/vars';
import classNames from 'classnames';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends ProgressConsistencyProps, HTMLProps, Pick<HighlightedProps, 'onElementClick'> {
  showOthersData?: boolean;
  /**
   * Students inside group.
   */
  students: ClassReportStudentType[];
  /**
   * Highlighted element(s) id.
   */
  highlightedIds?: number[] | null;
}

const genders: Record<number, GenderType> = {
  1: 'male',
  2: 'female',
  3: 'other',
};

const ProgressConsistencyGroup = (
  {
    showOthersData,
    headline,
    background,
    students,
    highlightedIds,
    onElementClick,
    ...other
  }: Props,
): JSX.Element => {

  return (
    <div className={classNames({ [STUDENT_PROGRESS_CLASSES.cursor]: onElementClick })}>
      <ProgressConsistencyWrapper
        background={background}
        headline={headline}
        length={students.length}
        {...other as HTMLProps}
      >
        {students.length === 0 ? null : (
          students.map((student) => (
            <Tooltip
              key={`consistency_${headline}_${student.id}`}
              tooltipMessage={student.fullName}
            >
              <div
                className={`flex items-center justify-center w-10 h-10 -mx-2 ${STUDENT_PROGRESS_CLASSES.element}`}
                data-cy={`student-icon-${student.id}`}
                onClick={() => onElementClick?.(student.id)}
              >
                <>
                  {showOthersData && highlightedIds?.includes(student.id)
                    ? <StudentIcon color={'primary'} size={70} />
                    : <StudentIcon color={genders[ student.gender ?? 1 ]} size={'lg'}/>
                  }
                </>
              </div>
            </Tooltip>
          ))
        )}
      </ProgressConsistencyWrapper>
    </div>
  );
};

export default ProgressConsistencyGroup;
